import * as React from 'react';

import * as styles from './RoomsQuickFilter.css';

export const RoomsQuickFilterTooltip = ({ children }: React.PropsWithChildren) => {
  return <div className={styles['container']}>{children}</div>;
};
